module.exports = __webpack_public_path__ + "static/media/015-Aktivierung_ID_19.ecef1261.mp3";